// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'
import http from './http'
import idcard from './idcard'

Vue.config.devtools = (process.env.NODE_ENV !== 'production')
Vue.config.productionTip = false

Vue.use(ElementUI)

Vue.prototype.$http = http
Vue.prototype.$idcard = idcard

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js